export default __webpack_public_path__ + "static/media/Birds_of_Paradise_design.0f91c151.png";